import React, { useState, useEffect } from "react";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import rtl from "jss-rtl";
import { create } from "jss";
import { StylesProvider, jssPreset } from "@material-ui/styles";
import { useSelector } from "react-redux";
import App from "./containers/App";
var hexToRgb = require("hex-rgb");


function ThemeApp() {
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const {
    lang,
    profile: { candidateCompany },
  } = useSelector((state) => state);
  const [direction, setDirection] = useState(lang === "en" ? "ltr" : "rtl");

  useEffect(() => {
    setDirection(lang === "en" ? "ltr" : "rtl");
  }, [lang]);

  const prime = hexToRgb(candidateCompany.primary_color, {
    format: "array",
  });
  const second = hexToRgb(candidateCompany.secondary_color, {
    format: "array",
  });
  const theme = createMuiTheme({
    direction: lang === "en" ? "ltr" : "rtl",
    palette: {
      primary: {
        main: `rgba(${prime[0]}, ${prime[1]}, ${prime[2]}, ${prime[3]})`,
      },
      secondary: {
        main: `rgba(${second[0]}, ${second[1]}, ${second[2]}, ${second[3]})`,
      },
    },
    typography: {
      fontFamily: [
        "Montserrat-Regular",
        "NeoSansArabic",
        "-apple-system",
        "Roboto",
        "Arial",
        "sans-serif",
      ].join(","),
    },
  });
  document.body.style.direction = direction;
  document.body.dir = direction;
  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StylesProvider>
  );
}

export default ThemeApp;
